import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { FuseTranslationLoaderService } from '~app/services/translation-loader.service';
import { HelpTopicState } from './help-topic.state';
import { locale as english } from './i18n/en';
import { locale as french } from './i18n/fr';

@NgModule({
  declarations: [],
  imports: [NgxsModule.forFeature([HelpTopicState])]
})
export class HelpTopicStoreModule {
  constructor(translationLoader: FuseTranslationLoaderService) {
    translationLoader.loadTranslations(english, french);
  }
}
